export default {
  'account_sidebar.account_information': 'Dane konta',
  'account_sidebar.addresses': 'Adresy',
  'account_sidebar.agreements': 'Zgody',
  'account_sidebar.billing': 'Dane do faktury',
  'account_sidebar.bonuses': 'Bonusy',
  'account_sidebar.branch': 'Oddziały',
  'account_sidebar.complains': 'Reklamacje',
  'account_sidebar.contact': 'Kontakt',
  'account_sidebar.dashboard': 'Dashboard',
  'account_sidebar.goods_issued_notes': 'Dokumenty WZ',
  'account_sidebar.goods_received_notes': 'Dokumenty WZK',
  'account_sidebar.invoice_corrections': 'Korekty',
  'account_sidebar.invoices': 'Faktury',
  'account_sidebar.invoices_goods_issued_notes': 'Faktury i dokumenty WZ',
  'account_sidebar.my_promotions': 'Moje promocje',
  'account_sidebar.notification_settings': 'Ustawienia powiadomień',
  'account_sidebar.offers': 'Oferty',
  'account_sidebar.order_authorization': 'Zamówienia do autoryzacji',
  'account_sidebar.orders_history': 'Historia zamówień',
  'account_sidebar.rfqs': 'Zapytania ofertowe',
  'account_sidebar.rfqs_offers': 'Oferty i Zapytania ofertowe',
  'account_sidebar.roles': 'Role',
  'account_sidebar.shopping_list': 'Lista zakupowa',
  'account_sidebar.title': 'Moje konto',
  'account_sidebar.users': 'Użytkownicy',
  'address_page_list_element.tooltip.billing': 'Adres rozliczeniowy <br>(na fakturze)',
  'address_page_list_element.tooltip.delivery': 'Domyślny adres dostawy',
  'address_page_list_element.tooltip.remove_address': 'Usuń adres',
  'address_page_list_element.tooltip.set_delivery': 'Ustaw jako domyślny adres dostawy',
  'address_page.add_address': 'Dodaj adres',
  'address_page.search': 'Szukaj w adresach',
  'address_page.search_placeholder': 'Szukaj',
  'address_page.title': 'Adresy',
  'agreements_page.email': 'Adres e-mail',
  'agreements_page.less': 'Mniej',
  'agreements_page.more': 'Więcej',
  'agreements_page.required_field_text': 'Pole wymagane',
  'agreements_page.title': 'Zgody',
  'alert_address_page.add_address': 'Dodano adres',
  'alert_address_page.error': 'Operacja nie powiodła się',
  'alert_address_page.remove_address': 'Usunięto adres',
  'alert_address_page.set_default_address': 'Zmieniono adres domyslny',
  'authorities.APP_ADD_ORDERS': 'Możliwość składania zamówień',
  'authorities.APP_ADD_TO_AUTHORIZATION_CART': 'Możliwość przesłania koszyka innemu użytkownikowi - do akceptacji',
  'authorities.APP_AUTHORIZATION_CART': 'Upoważnienie do akceptacji koszyków',
  'authorities.APP_DELIVERY_PICKUP': 'Upoważnienie do odbioru zamówień',
  'authorities.APP_USERS': 'Możliwość zarządzania rolami i użytkownikami',
  'authorities.APP_VIEW_INVOICES': 'Podgląd zakładki - faktury',
  'authorities.APP_VIEW_ORDERS': 'Podgląd historii zamówień wszystkich użytkowników',
  'authorities.APP_VIEW_PRICES': 'Podgląd cen',
  'authorities.APP_VIEW_ROLES': 'Możliwość tworzenie i edytować ról użytkowników',
  'authorities.APP_VIEW_USERS': 'Możliwość edytowania i zakładania nowych użytkowników',
  'availability_override.available': 'Zawsze dostępny',
  'availability_override.not_available': 'Zawsze niedostępny',
  'backend_errors.account-account-manager-account-manager-not-found': 'Nie rozpoznano kodu twojego opiekuna',
  'backend_errors.account-account-client-invoice-agreement-required': 'Zgoda na fakturę jest wymagana',
  'backend_errors.account-account-client-tin-used': 'Podany numer NIP jest już zarejestrowany. Jeśli chcesz zarejestrować się jako pracownik, skontaktuj się ze swoim opiekunem lub <a href="https://onecommerce.shop" target="_blank">naszym biurem obsługi klienta.</a>',
  'backend_errors.account-account-registration-account-registration-country-is-required': 'Kraj jest wymagany',
  'backend_errors.account-account-registration-account-registration-email-already-in-use': 'Ten adres e-mail jest już zajęty. Poproś o przypomnienie hasła. Jeśli nadal nie możesz się zalogować, skontaktuj się ze swoim opiekunem lub <a href="https://onecommerce.shop" target="_blank">naszym biurem obsługi klienta.</a>',
  'backend_errors.account-account-registration-account-registration-tin-already-in-use': 'Podany numer NIP istnieje w systemie. Proszę skontaktować się z działem obsługi klienta.',
  'backend_errors.account-registration-invalid-email': 'Podany adres email jest nieprawidłowy',
  'backend_errors.CANNOT_BE_ORDER': 'Brak możliwości złożenia zamówienia',
  'backend_errors.default': 'Wystąpił błąd - spróbuj ponownie później',
  'backend_errors.NOT_ENOUGH_TRADE_CREDIT': 'Brak możliwości złożenia zamówienia z powodu niewystarczających środków',
  'backend_errors.ORDER_ALREADY_SUBMITTED': 'Zamówienie zostało już złożone',
  'backend_errors.orderpath-offer-command-CanNotPlaceOrderError': 'W koszyku znajduje się usunięty produkt. Usuń produkt, żeby zrealizować zamówienie',
  'backend_errors.orderpath-order-BlockedClientCreateOrderError': 'Brak możliwości złożenia zamówienia z powodu blokady',
  'backend_errors.orderpath-order-ExternalAccountBlockadeRequestError': 'Brak odpowiedzi z zewnętrznego systemu',
  'backend_errors.orderpath-order-ExternalTradeCreditRequestError': 'Brak odpowiedzi z zewnętrznego systemu',
  'backend_errors.orderpath-validate-coupon-coupon-expired': 'Kod promocyjny utracił ważność',
  'backend_errors.orderpath-validate-coupon-coupon-not-found': 'Kod promocyjny nie został odnaleziony',
  'backend_errors.orderpath-validate-coupon-coupon-only-for-authorized-users': 'Kod promocyjny dla autoryzowanych użytkowników',
  'backend_errors.orderpath-validate-coupon-coupon-usage-limit-reached': 'Pula kodów została wyczerpana',
  'backend_errors.rma-complaint-EmailValidationError': 'Adres e-mail nie jest poprawny',
  'backend_errors.rma-complaint-ItemsValidationError': 'Wybierz produkty reklamowane',
  'backend_errors.rma-complaint-PositionOnInvoiceValidationError': 'Pozycja na fakturze powinna być inna niż 0',
  'backend_errors.rma-complaint-QuantityValidationError': 'Wybierz ilość reklamowaną',
  'backend_errors.USER_DOES_NOT_EXIST': 'Brak możliwości złożenia zamówienia. Użytkownik nie istnieje',
  'backend_errors.USER_IS_NOT_ACTIVE': 'Użytkownik jest nieaktywny',
  'barcode_reader.not_available': 'Urządzenie nie obsługuje kamery lub brak zezwolenia',
  'barcode_reader.not_found': 'Nie znaleziono produktów',
  'barcode_reader.scan_again': 'Skanuj ponownie',
  'barcode_reader.search_placeholder': 'Zeskanuj lub wpisz kod EAN',
  'barcode_reader.searching': 'Wyszukiwanie',
  'barcode_reader.select_device': 'Wybierz kamerę',
  'billing_view.city': 'Miasto',
  'billing_view.country': 'Kraj',
  'billing_view.email': 'E-mail',
  'billing_view.external_id': 'Numer klienta z ERP:',
  'billing_view.name': 'Nazwa firmy',
  'billing_view.phone': 'Telefon',
  'billing_view.street': 'Ulica i numer',
  'billing_view.tin': 'NIP',
  'billing_view.title': 'Dane do faktury',
  'billing_view.zip_code': 'Kod pocztowy',
  'blog.no_articles': 'Brak artykułów',
  'blog.read_more': 'Czytaj więcej',
  'blog.title': 'BLOG',
  'cart.availability': 'Dostępność',
  'cart.availability_error': 'Uwaga! Ilość produktów wybrana przez Ciebie, przekracza ilość dostępną na magazynie. Zdecyduj jak mamy traktować Twoje zamówienie:',
  'cart.availability_error_option1': 'Zamawiam produkty w ilości aktualnie dostępnej, pozostałe zostaną dosłane w momencie uzupełnienia stanu magazynowe inną przesyłką.',
  'cart.availability_error_option2': 'Zamawiam produkty w ilości aktualnie dostępnej, pozostałe proszę usunąć z koszyka.',
  'cart.availability_error_option3': 'Zamawiam produkty w ilości aktualnie dostępnej, pozostałe proszę przenieść do innego koszyka.',
  'cart.availability_error_option4': 'Zamawiam produkty w pełnej ilości, co oznacza oczekiwanie na kompletację przesyłki.',
  'cart.award_campaigns.change_awards': 'Zmień swoje nagrody',
  'cart.award_campaigns.choose_awards': 'Dodaj swoje nagrody',
  'cart.award_campaigns.selected': 'wybrano:',
  'cart.back': 'Powrót',
  'cart.blockades.client': 'Z powodu nałożonej blokady, możliwość złożenia zamówienia została wyłączona, aby dowiedzieć się więcej skontaktuj się ze swoim opiekunem',
  'cart.blockades.sale': 'Z powodu nałożonej blokady, możliwość złożenia zamówienia została wyłączona, masz możliwość wysłania koszyka tylko w formie zapytania ofertowego, aby dowiedzieć się więcej skontaktuj się ze swoim opiekunem',
  'cart.blockades.trade_credit': 'Płatność kredytem kupieckim została wyłączona z powodu nałożonej blokady, aby dowiedzieć się więcej skontaktuj się ze swoim opiekunem',
  'cart.btn': 'Przejdź do danych adresowych',
  'cart.btn_authorize': 'Wyślij zamówienie do autoryzacji',
  'cart.btn_rfq': 'Złóż zapytanie ofertowe',
  'cart.btn_send': 'Wyślij',
  'cart.calculate': 'Przelicz koszyk',
  'cart.cancel_calculate': 'Anuluj zmiany',
  'cart.cart_authorization_from_user': 'Koszyk do autoryzacji od użytkownika:',
  'cart.change': 'Zmień',
  'cart.coupon_added': 'Dodano kupon do koszyka',
  'cart.coupon_delete_btn': 'Usuń',
  'cart.coupon_deleted': 'Usunięto wpisany kupon',
  'cart.coupon_not_valid': 'Podany kupon jest nieprawidłowy lub wykorzystany',
  'cart.coupon_valid': 'Kupon poprawny',
  'cart.default_name': 'Koszyk',
  'cart.delivery_method_error': 'Błąd metod dostawy',
  'cart.delivery_methods': 'Opcje dostawy',
  'cart.delivery_methods_placeholder': 'Wybierz sposób dostawy',
  'cart.delivery_number': 'Numer dostawy',
  'cart.delivery_warehouse_placeholder': 'Wybierz magazyn',
  'cart.dropdown.add_new': 'Dodaj koszyk',
  'cart.dropdown.delete': 'Usuń aktualny koszyk',
  'cart.dropdown.export_cart': 'Eksportuj produkty do pliku',
  'cart.dropdown.export_info': 'Tutaj możesz eksportować z koszyka całą listę produktów wraz z ilościami do pliku w formacie CSV',
  'cart.dropdown.import_cart': 'Importuj produkty',
  'cart.dropdown.import_info': 'Tutaj możesz zaimportować całą swoją listę produktów do koszyka za pomocą pliku CSV, XLS lub XLSX. Aby import odbył się poprawnie plik należy przygotować według schematu:',
  'cart.dropdown.import_info_column_1': 'Kolumna 1: Id produktu / Kod produktu / GTIN',
  'cart.dropdown.import_info_column_2': 'Kolumna 2: Ilość',
  'cart.dropdown.rename': 'Zmień nazwę koszyka',
  'cart.edit_product': 'Edytuj produkt',
  'cart.empty_cart': 'Koszyk pusty',
  'cart.empty_cart_error': 'Koszyk nie może być pusty',
  'cart.extra': 'Doliczyć koszty przesyłki do produktów?',
  'cart.extra_option': 'Opcje dodatkowe',
  'cart.free_delivery': 'Do darmowej dostawy brakuje',
  'cart.import_errors.column': 'Kolumna {0}.',
  'cart.import_errors.empty_field': 'Nie uzupełnione wszystkie pola.',
  'cart.import_errors.internal': 'Wewnętrzny błąd podczas importu produktu.',
  'cart.import_errors.nonpositive_amount': 'Wartości ujemne nie są dozwolone.',
  'cart.import_errors.not_number_field': 'Wprowadzona wartość jest niepoprawna. Powinna być liczbowa.',
  'cart.import_errors.price_not_found': 'Nie znaleziono ceny.',
  'cart.import_errors.product_amount_is_incorrect_for_product_interval': 'Ilość produktu jest niezgodna z interwałem.',
  'cart.import_errors.product_amount_less_than_minimum_quantity': 'Nie można zamówić produktu poniżej minimalnej ilości.',
  'cart.import_errors.product_not_found': 'Nie znaleziono produktu.',
  'cart.import_errors.product_with_block_label': 'Nie można zamówić tego produktu ponad stan magazynowy.',
  'cart.import_errors.row': 'Wiersz {0}.',
  'cart.import_errors.undefined_field_type': 'Nieprawidłowa wartość.',
  'cart.import_errors.unexpected_value': 'Nieoczekiwana wartość.',
  'cart.import_errors.not_enough_available_quantity': 'Nie udało się zaimportować pełnej zadeklarowanej ilości produktu.',
  'cart.invalid_quantity_message': 'Nie można dodać takiej ilości produktów',
  'cart.inventory': 'Magazyn',
  'cart.modals.add_placeholder': 'Wprowadź nazwę koszyka',
  'cart.modals.add_title': 'Dodaj nowy koszyk',
  'cart.modals.amount_change_cancel': 'Anuluj zmiany',
  'cart.modals.amount_change_recalculate': 'Przelicz koszyk',
  'cart.modals.amount_change_text': 'Dokonano zmian ilości produktów. Prosimy o potwierdzenie lub anulowanie zmian.',
  'cart.modals.amount_change_title': 'Zmiana wartości na koszyku',
  'cart.modals.browse': 'Przeglądaj',
  'cart.modals.cancel_btn': 'Anuluj',
  'cart.modals.cart_created': 'Dodano nowy koszyk',
  'cart.modals.cart_removed': 'Koszyk usunięty',
  'cart.modals.cart_renamed': 'Zmieniono nazwę koszyka',
  'cart.modals.confirm_btn': 'Zatwierdz',
  'cart.modals.drop_file_placeholder': 'Upuść plik ...',
  'cart.modals.error_import_product': 'Nie udało się zaimportować produktów',
  'cart.modals.file_placeholder': 'Wybierz plik lub upuść go tutaj ...',
  'cart.modals.import_btn': 'Importuj',
  'cart.modals.import_title': 'Importuj produkty do koszyka',
  'cart.modals.input_not_valid': 'Za długa nazwa koszyka',
  'cart.modals.product_search': 'Szukaj produktów',
  'cart.modals.product_search_placeholder': 'Wpisz',
  'cart.modals.promotion_fetch_error': 'Wystąpił problem przy pobieraniu promocji. Spróbuj ponownie później.',
  'cart.modals.promotion_title': 'Wybierz nagrody z promocji',
  'cart.modals.remove_confirm_btn': 'Usuń',
  'cart.modals.remove_text': 'Proszę potwierdzić usunięcie koszyka',
  'cart.modals.remove_title': 'Usuwanie koszyka',
  'cart.modals.rename_ok_btn': 'Zmień nazwę',
  'cart.modals.rename_placeholder': 'Podaj nową nazwę koszyka',
  'cart.modals.rename_title': 'Zmiana nazwy koszyka',
  'cart.modals.save_btn': 'Zapisz',
  'cart.modals.select_locker': 'Wybierz paczkomat',
  'cart.modals.selected_file': 'Wybrany plik:',
  'cart.modals.selected_promotion': 'Wybrano',
  'cart.modals.shipping_locker_cash_info': 'Szanowny kliencie, wybrałeś płatność przy odbiorze, która jest dostępna w bardzo małej ilości paczkomatów. Zmień na inną formę płatności, aby zobaczyć pełną listę paczkomatów.',
  'cart.modals.success_import_product': 'Udało się zaimportować produkty do koszyka',
  'cart.no_delivery_method_selected': 'Wybierz metodę dostawy',
  'cart.no_delivery_methods': 'Wybrany magazyn nie posiada metod dostawy',
  'cart.no_payment_method_set': 'Nie wybrano metody płatności',
  'cart.no_split_shipment_option': 'Zrealizuj zamówienie, gdy wszystkie towary będą dostępne',
  'cart.no_user_set': 'Wybierz użytkownika',
  'cart.notes': 'Uwagi',
  'cart.notification': 'Towary będą gotowe do odbioru w ciągu 4 godzin od złożenia. Poinformujemy Państwa o realizacji.',
  'cart.options': 'Akcje',
  'cart.order_submitted': 'Zamówienie zostało już złożone.',
  'cart.payment_methods': 'Metody płatności',
  'cart.payment_methods_unavailable': 'Wybór metody płatności możliwy po ustaleniu metody dostawy na wysyłkach',
  'cart.please_select_locker': 'Proszę wybierz paczkomat',
  'cart.price': 'Cena',
  'cart.products_available': 'Produkty dostępne',
  'cart.products_ordered': 'Produkty',
  'cart.products_some_available': 'Produkty częściowo dostępne',
  'cart.products_unavailable': 'Produkty niedostępne',
  'cart.promo_points_added': 'Punkty zostały dodane',
  'cart.promo_points_deleted': 'Usunięto punkty',
  'cart.promo_points_usage_info': `Wykorzystano <span class="font-weight-bold">{0}</span> z zadeklarowanych {1} punktów`,
  'cart.promotion_coupon': 'Kupon promocyjny',
  'cart.promotion_points': 'Twoje punkty lojalnościowe',
  'cart.promotion_points_info': 'Wpisz wartość punktową którą chciałbyś przeznaczyć na rabaty i przelicz koszyk',
  'cart.quantity': 'Ilość',
  'cart.quantity_error': 'Ilość zamawianych produktów niedostępna, wróć do koszyka.',
  'cart.remove_selected_products': 'Usuń wybrane produkty',
  'cart.return_text': 'Powrót',
  'cart.rfq_banner_above_max': 'Wartość koszyka przekroczyła maksymalną kwotę umożliwiającą złożenie zamówienia, prześlij koszyk w formie zapytania ofertowego, a nasz pracownik skontaktuje się z Tobą w najbliższym możliwym terminie.',
  'cart.rfq_banner_between_min_max': 'Masz możliwość wysłania koszyka w formie zapytania ofertowego w celu negocjacji warunków handlowych. Wybór opcji wysłania koszyka w formie zapytania ofertowego lub zamówienia znajduje się na podsumowaniu ścieżki zakupowej.',
  'cart.rfq_banner_labels': 'W koszyku znajdują się produkty, które wymagają weryfikacji. Masz możliwość wysłania koszyka tylko w formie zapytania ofertowego, opcja znajduje się na podsumowaniu ścieżki zakupowej.',
  'cart.rfq_banner_product_without_price': 'Nie można złożyć zamówienia. Brak ceny produktu',
  'cart.select': 'Wybierz',
  'cart.select_all_products': 'Wybierz wszystkie produkty',
  'cart.shipment_name': 'Przesyłka',
  'cart.simplepay_image': 'SimplePay - płatności online',
  'cart.simplepay_info': 'SimplePay informacja dla klienta',
  'cart.simplepay_order_cancelled_title': 'Transakcja anulowana',
  'cart.simplepay_order_subtitle': 'Identyfikator transakcji SimplePay',
  'cart.simplepay_order_successful_title': 'Udana transakcja',
  'cart.simplepay_order_unsuccessful_text': 'Sprawdź, czy informacje podane podczas transakcji są prawidłowe. Jeśli wszystkie informacje zostały wprowadzone poprawnie, skontaktuj się z bankiem, który wydał kartę, w celu zbadania przyczyny odrzucenia.',
  'cart.simplepay_order_unsuccessful_title': 'Nieudana transakcja',
  'cart.some_products_are_not_available': 'Możliwość zamówienia poniższych produktów ponad dostępny stan magazynowy została zablokowana, zaaktualizuj ilości produktów w koszyku:',
  'cart.some_products_are_not_available_one': 'ilość możliwa do zamówienia:',
  'cart.some_products_are_not_available_two': 'aktualna ilość w koszyku:',
  'cart.specific_stock.available': 'dostępne',
  'cart.specific_stock.not_available': 'niedostępne',
  'cart.specific_stock.some_available': 'częściowo dostępne',
  'cart.specific_stock.warehouse_info': 'Informacje o stanach magazynowych',
  'cart.split_shipment_option': 'Podziel zamówienie na towary dostępne oraz niedostępne',
  'cart.status_canceled': 'Anulowane',
  'cart.status_failed': 'Nieudane',
  'cart.status_paid': 'Opłacone',
  'cart.status_pending': 'Oczekiwanie na płatność',
  'cart.status_timeout': 'Czas minął',
  'cart.summary': 'Podsumowanie',
  'cart.summary_cart_discount_placeholder': 'Jeśli masz kod rabatowy, wpisz go tutaj',
  'cart.summary_cart_notes_placeholder': 'Tutaj możesz dołączyć wszelkie notatki do swojego zamówienia ...',
  'cart.summary_cart_order_number_placeholder': 'Wpisz nr zamówienia',
  'cart.summary_cart_points_placeholder': 'Wpisz ilość punktów do wykorzystania',
  'cart.summary_table_additional_costs': 'KGO',
  'cart.summary_table_payment': 'Płatność',
  'cart.summary_table_product': 'Produkty',
  'cart.summary_table_shipment': 'Wysyłka',
  'cart.summary_table_tax': 'Podatek VAT',
  'cart.summary_table_total': 'Suma',
  'cart.summary_table_total_gross': 'Suma [brutto]',
  'cart.support': 'Wsparcie techniczne',
  'cart.support_phone': '+48 0800 800 800',
  'cart.tooltip': 'Informacja o...',
  'cart.total_price': 'Suma',
  'cart.total_price_gross': 'Suma brutto',
  'cart.total_price_net': 'Suma netto',
  'cart.trade_credit': 'Twój limit wynosi: ',
  'cart.trade_credit_available': 'Pozostały limit: ',
  'cart.trade_credit_error': 'Nie masz wystarczających środków',
  'cart.trade_credit_error_notification': 'Wartość koszyka przekracza Twój dostępny limit kupiecki',
  'cart.trade_credit_used': 'Limit wykorzystany: ',
  'cart.your_promotions': 'Promocje na cały koszyk',
  'change_password_page.bad_credentials': 'Podane hasło jest nieprawidłowe lub coś poszło nie tak.',
  'change_password_page.error': 'Nie udało się zmienić hasła lub coś poszło nie tak.',
  'change_password_page.error_login': 'Coś poszło nie tak. Zaloguj się ponownie.',
  'change_password_page.feedback_cross_field_validation': 'Nowe hasła nie pasują do siebie',
  'change_password_page.feedback_new_password': 'Nowe hasło jest wymagane. Musisz wpisać jedną wielką literę, jedną cyfrę lub znak specjalny, min. 8 znaków',
  'change_password_page.feedback_old_password': 'Stare hasło jest wymagane',
  'change_password_page.feedback_re_enter_new_password': 'Powtórzenie nowego hasła jest wymagane',
  'change_password_page.info_invalid_token': 'Link umożliwiający zresetowanie hasła wygasł, albo jest nieprawidłowy. Spróbuj ponownie zresetować hasło.',
  'change_password_page.is_agreements_accepted': 'Wymagane zaakceptowanie regulaminu',
  'change_password_page.label': 'Zapisz nowe hasło',
  'change_password_page.new_password': 'Nowe hasło',
  'change_password_page.new_password_title': 'Podaj nowe hasło',
  'change_password_page.old_password': 'Stare hasło',
  'change_password_page.repeat_new_password': 'Powtórz nowe hasło',
  'change_password_page.resend_new_password': 'Na podany adres e-mail został wysłany link gdzie dokończysz utworzenie konta',
  'change_password_page.success': 'Udało się zmienić hasło. Zaloguj się ponownie.',
  'change_password_page.title': 'Zostałeś zalogowany po raz pierwszy. Wymagana zmiana hasła jednorazowego.',
  'checkout.accepted_delivery_date': 'Potwierdzona data dostawy',
  'checkout.contract_conditions.city': 'Miasto',
  'checkout.contract_conditions.company_name': 'Nazwa firmy',
  'checkout.contract_conditions.country': 'Kraj',
  'checkout.contract_conditions.phone': 'Telefon',
  'checkout.contract_conditions.street': 'Ulica i numer',
  'checkout.contract_conditions.tin': 'NIP',
  'checkout.contract_conditions.zip_code': 'Kod pocztowy',
  'checkout.delivery.add_new_address': 'Dodaj nowy adres',
  'checkout.delivery.addAddress': 'Dodaj adres do książki adresowej',
  'checkout.delivery.address_name': 'Nazwa adresu',
  'checkout.delivery.another_delivery_address': 'Adres dostawy inny niż adres do faktury',
  'checkout.delivery.authorizedPersons': 'Upoważnij do odbioru',
  'checkout.delivery.availabilityTxt': 'Dostępny',
  'checkout.delivery.chosenMethod': 'Dostawa kurierem 24h',
  'checkout.delivery.city': 'Miasto',
  'checkout.delivery.country': 'Państwo',
  'checkout.delivery.date': 'Wybierz datę',
  'checkout.delivery.email': 'E-mail',
  'checkout.delivery.error': 'Nieprawidłowy adres',
  'checkout.delivery.error_add_address': 'Błąd przy dodawaniu nowego adresu',
  'checkout.delivery.exactDeliveryDate': 'Dokładna data dostawy',
  'checkout.delivery.itemAvailability': 'Towar dostępny w magazynie',
  'checkout.delivery.list_address': 'Wybierz z listy adresów',
  'checkout.delivery.list_user': 'Wybierz odbiorcę',
  'checkout.delivery.name': 'Imię i nazwisko',
  'checkout.delivery.new_address': 'Podaj nowy adres',
  'checkout.delivery.new_user': 'Podaj nowego odbiorcę',
  'checkout.delivery.newAddressExists': 'Wpisany adres istnieje już w książce adresowej!',
  'checkout.delivery.phone': 'Telefon',
  'checkout.delivery.select_authorized_users': 'Wybierz odbiorców',
  'checkout.delivery.guest_user_data': 'Dane odbiorcy',
  'checkout.delivery.street': 'Ulica i numer',
  'checkout.delivery.success_add_address': 'Dodano nowy adres',
  'checkout.delivery.title': 'Dostawa przesyłka numer ',
  'checkout.delivery.type_another_address': 'Wprowadź inny adres',
  'checkout.delivery.value': 'Wartość',
  'checkout.delivery.zip_code': 'Kod pocztowy',
  'checkout.estimated_delivery_date': 'Planowana data dostawy',
  'checkout.full_value_basket': 'Łączna wartość',
  'checkout.full_value_basket_address': 'Łączna wartość',
  'checkout.full_value_basket_cart': 'Łączna wartość',
  'checkout.full_value_basket_summary': 'Łączna wartość',
  'checkout.invoice_data.title': 'Dane do faktury',
  'checkout.moreRead.less': 'Czytaj mniej',
  'checkout.moreRead.more': 'Czytaj więcej',
  'checkout.notes': 'Uwagi',
  'checkout.options.btn_order': 'Potwierdź zakup',
  'checkout.options.btn_pay_with_stripe': 'Opłać z użyciem Stripe',
  'checkout.options.btn_stripe': 'Opłać',
  'checkout.options.btn_submit': 'Prześlij jako zapytanie ofertowe',
  'checkout.options.btn_summary': 'Podsumowanie',
  'checkout.options.btn_try_again': 'Spróbuj ponownie',
  'checkout.payment_method': 'Wybrana metoda płatności',
  'checkout.payment_notice': 'Złożenie zamówienia wiąże się z obowiązkiem zapłaty!',
  'checkout.paywall_failed': 'Wystąpił problem z metodą płatności. Spróbuj ponownie lub później',
  'checkout.regulations.error_accept_regulations': 'Zaakceptuj regulamin!',
  'checkout.regulations.title': 'Zgody',
  'checkout.summary.cart_auth': 'Dziękujemy, twój koszyk został przesłany do autoryzacji.',
  'checkout.summary.cart_rfq1': 'Dziękujemy, twoje zapytanie ofertowe o numerze',
  'checkout.summary.delivery_number': 'Nr zamówienia',
  'checkout.summary.invoice_data': 'Dane do faktury',
  'checkout.summary.order_status': 'Status zamówienia',
  'checkout.summary.step1': 'Otrzymasz na skrzynkę e-mail potwierdzenie',
  'checkout.summary.step2': 'Twoje zamówienie zostanie zweryfikowane',
  'checkout.summary.step3': 'Powiadomimy Cię o kompletacji zamówienia',
  'checkout.summary.step4': 'Przesyłkę wyślemy lub przygotujemy do odbioru',
  'checkout.summary.thank_you_guest': 'Dziękujemy za złożenie zamówienia',
  'checkout.summary.thank_you_guest_info': 'Szczegóły dotyczące zamówienia zostaną przesłane na podany adres email',
  'checkout.summary.thank_you_fail_first': 'Twoje zamówienie o numerze',
  'checkout.summary.thank_you_fail_second': 'nie zostało zrealizowane.',
  'checkout.summary.thank_you_success_first': 'Dziękujemy. Twoje zamówienie o numerze',
  'checkout.summary.thank_you_success_second': 'zostało pomyślnie wysłane.',
  'checkout.summary.total_price': 'Suma do zapłaty',
  'checkout.summary.what_next': 'Co dalej?',
  'common.cancel': 'Anuluj',
  'common.edit': 'Edytuj',
  'common.save': 'Zapisz',
  'company_branches.change_tip': 'Jesli chcesz zmienić swój domyślny oddział, skontaktuj się z administratorem' + ' konta',
  'company_branches.consultant': 'Opiekun klienta',
  'company_branches.title': 'Oddział',
  'complains.cancel_complaint': 'Anuluj formularz',
  'complains.complains_number': 'Reklamacja',
  'complains.complaint_reason': 'Powód',
  'complains.create_complaint': 'Złóż formularz',
  'complains.create_date': 'Data utworzenia',
  'complains.declarant': 'Zgłaszający',
  'complains.demand': 'Żądanie klienta',
  'complains.detail.document': 'Do dokumentu',
  'complains.detail.invoice_number': 'Do faktury',
  'complains.detail.notes': 'Uwagi',
  'complains.email': 'E-mail',
  'complains.email_not_valid': 'Adres e-mail nie jest poprawny',
  'complains.empty_complaint_items': 'Wybierz produkty reklamowane',
  'complains.empty_position_invoice': 'Pozycja na fakturze powinna być inna niż 0',
  'complains.empty_quantity': 'Wybierz ilość reklamowaną',
  'complains.goods_issued_note': 'Dokument WZ',
  'complains.invoice': 'Faktura',
  'complains.lp': 'L.p',
  'complains.name': 'Imię i nazwisko',
  'complains.notes': 'Opis wady',
  'complains.notes_input': 'Opisz wadę, datę jej stwierdzenia oraz żądanie z tytułu reklamacji',
  'complains.notification_info': 'W celu złożenia reklamacji, wypełnij poniższy formularz. Po złożeniu wniosku na adres e-mail wskazany w formularzu zostanie przesłany numer zgłoszenia. Dział reklamacji skontaktuje sie z Tobą w celu przedstawienia dalszego procesu postępowania.',
  'complains.phone': 'Numer telefonu',
  'complains.position_on_invoice': 'Pozycja na fakturze',
  'complains.product': 'Produkt',
  'complains.product_sku': 'SKU produktu',
  'complains.quantity_on_invoice': 'Ilość na fakturze',
  'complains.quantity_to_return': 'Ilość reklamowana',
  'complains.save_complaint': 'Złóż wniosek',
  'complains.status': 'Status',
  'complains.step_1': 'Krok 1. Wybierz dokument',
  'complains.step_2': 'Krok 2. Wyszukaj dokument',
  'complains.step_3': 'Krok 3. Wybierz produkty, które chcesz zareklamować',
  'complains.step_4': 'Krok 4. Wprowadź dane',
  'complains.success_complaint': 'Utworzono reklamację',
  'complains.unit': 'Jednostka',
  'default_seo.category': 'Kategoria:',
  'default_seo.description': 'Najlepsza platforma ecommerce',
  'default_seo.keywords': 'One, Platforma, Ecommerce',
  'default_seo.search': 'Wynik wyszukiwania dla:',
  'default_seo.title': 'One',
  'edit_address_view.cancel': 'Anuluj',
  'edit_address_view.city': 'Miasto',
  'edit_address_view.country': 'Kraj',
  'edit_address_view.default': 'Ustaw jako domyślny',
  'edit_address_view.name': 'Nazwa firmy',
  'edit_address_view.phone': 'Numer telefonu',
  'edit_address_view.save': 'Zapisz',
  'edit_address_view.street': 'Ulica i numer',
  'edit_address_view.title': 'Dodaj adress',
  'edit_address_view.zipCode': 'Kod pocztowy',
  'error_page.copy': 'Skopiuj do schowka',
  'error_page.error_occurred': 'Wystąpił błąd',
  'error_page.home_page': 'Powrót do strony głównej',
  'error_page.info_req_id': 'Przepraszam, coś poszło nie tak. Zespół wysoce wyszkolonych programistów został wysłany, aby poradzić sobie z sytuacją.',
  'error_page.not_found': 'Nie znaleziono strony',
  'errors.add_to_cart_error': 'Błąd dodawania do koszyka',
  'errors.add_to_wishlist_error': 'Błąd dodawania do listy zakupowej',
  'errors.generic': 'Wystąpił błąd - spróbuj ponownie później',
  'errors.no_cart_authorization': 'Użytkownik nie istnieje / Potwierdzenie zamówienia zostało już przesłane / Użytkownik docelowy nie istnieje lub jest w innej organizacji lub nie ma autoryzacji',
  'errors.no_prices': 'Cena tego produktu jest niedostępna, nie możesz go zakupić.',
  'errors.no_warehouses': 'Nie wprowadzono magazynów - system nie będzie w pełni funkcjonalny',
  'errors.no_warehouses_cart': 'Nie wprowadzono magazynów - koszyk niedostępny',
  'errors.submit_error_400': 'Wystąpił problem (400) - spróbuj ponownie później',
  'errors.submit_error_500': 'Wystąpił problem (500) - spróbuj ponownie później',
  'errors.warning': 'Uwaga',
  'fields_lang.city': 'Miejscowość',
  'fields_lang.company': 'Nazwa firmy',
  'fields_lang.country': 'Kraj',
  'fields_lang.department': 'Oddział',
  'fields_lang.email': 'E-mail',
  'fields_lang.fullName': 'Imię i nazwisko',
  'fields_lang.guardian': 'Kod twojego opiekuna',
  'fields_lang.invoiceEmail': 'Email e-faktur',
  'fields_lang.password': 'Hasło',
  'fields_lang.phone': 'Telefon',
  'fields_lang.rePassword': 'Powtórz hasło',
  'fields_lang.street': 'Ulica i numer',
  'fields_lang.tin': 'NIP',
  'fields_lang.zipCode': 'Kod pocztowy',
  'footer.about_us': 'O nas',
  'footer.contact': 'Kontakt',
  'footer.cookie_accept': 'Zgadzam się',
  'footer.customer_service': 'Obsługa klienta',
  'footer.how_to_buy': 'Jak kupować',
  'footer.information': 'Informacje',
  'footer.mobile.account': 'Konto',
  'footer.mobile.cart': 'Koszyk',
  'footer.mobile.categories': 'Menu',
  'footer.mobile.home': 'Start',
  'global.delete': 'Usuń',
  'global.export_to_file': 'Eksportuj do pliku',
  'global.loading_prices': 'Ładowanie cen',
  'global.no_photo': 'Brak zdjęcia',
  'global.remove': 'Usuń',
  'goods_issued_notes.details.city': 'Miasto',
  'goods_issued_notes.details.client_data': 'Dane klienta',
  'goods_issued_notes.details.country': 'Kraj',
  'goods_issued_notes.details.delivery_address': 'Adres dostawy',
  'goods_issued_notes.details.name': 'Nazwa',
  'goods_issued_notes.details.postCode': 'Kod pocztowy',
  'goods_issued_notes.details.price': 'Cena [Netto/Brutto]',
  'goods_issued_notes.details.products': 'Produkty',
  'goods_issued_notes.details.products_title': 'Produkty dla WZ o numerze ',
  'goods_issued_notes.details.purchase_order_number': 'Numer zamówienia klineta',
  'goods_issued_notes.details.quantity': 'Ilość',
  'goods_issued_notes.details.street': 'Ulica i numer',
  'goods_issued_notes.details.tin': 'NIP',
  'goods_issued_notes.details.value': 'Wartość [Netto/Brutto]',
  'goods_issued_notes.lp': 'L.p.',
  'goods_issued_notes.note_date': 'Data dokumentu',
  'goods_issued_notes.note_details': 'Podgląd WZ',
  'goods_issued_notes.note_gross_value': 'Wartość brutto',
  'goods_issued_notes.note_invoice': 'Faktura',
  'goods_issued_notes.note_number': 'Dokument WZ',
  'goods_issued_notes.note_order': 'Podgląd zamówienia',
  'goods_issued_notes.note_orders': 'Zamówienie',
  'goods_issued_notes.note_pdf': 'Pobierz WZ jako PDF',
  'goods_issued_notes.note_sale_date': 'Data sprzedaży',
  'goods_issued_notes.note_search': 'Szukaj w WZ',
  'goods_issued_notes.note_sort': 'Sortuj WZ',
  'goods_issued_notes.note_sort_asc': 'Rosnąco',
  'goods_issued_notes.note_sort_desc': 'Malejąco',
  'goods_issued_notes.notes': 'Uwagi',
  'goods_issued_notes.notes_title': 'Dokumenty WZ',
  'goods_issued_notes.options': 'Opcje',
  'goods_issued_notes.sum_selected': 'Suma wybranych WZ brutto',
  'goods_received_notes.details.city': 'Miasto',
  'goods_received_notes.details.client_data': 'Dane klienta',
  'goods_received_notes.details.country': 'Kraj',
  'goods_received_notes.details.delivery_address': 'Adres dostawy',
  'goods_received_notes.details.name': 'Nazwa',
  'goods_received_notes.details.postCode': 'Kod pocztowy',
  'goods_received_notes.details.price': 'Cena [Netto/Brutto]',
  'goods_received_notes.details.products': 'Produkty',
  'goods_received_notes.details.products_title': 'Produkty dla WZK o numerze ',
  'goods_received_notes.details.purchase_order_number': 'Numer zamówienia klineta',
  'goods_received_notes.details.quantity': 'Ilość',
  'goods_received_notes.details.street': 'Ulica i numer',
  'goods_received_notes.details.tin': 'NIP',
  'goods_received_notes.details.value': 'Wartość [Netto/Brutto]',
  'goods_received_notes.lp': 'L.p.',
  'goods_received_notes.note_date': 'Data dokumentu',
  'goods_received_notes.note_details': 'Podgląd WZK',
  'goods_received_notes.note_gross_value': 'Wartość brutto',
  'goods_received_notes.note_invoice': 'Faktura',
  'goods_received_notes.note_number': 'Dokument WZK',
  'goods_received_notes.note_order': 'Podgląd zamówienia',
  'goods_received_notes.note_orders': 'Zamówienie',
  'goods_received_notes.note_pdf': 'Pobierz WZK jako PDF',
  'goods_received_notes.note_sale_date': 'Data sprzedaży',
  'goods_received_notes.note_search': 'Szukaj w WZK',
  'goods_received_notes.note_sort': 'Sortuj WZK',
  'goods_received_notes.note_sort_asc': 'Rosnąco',
  'goods_received_notes.note_sort_desc': 'Malejąco',
  'goods_received_notes.notes': 'Uwagi',
  'goods_received_notes.notes_title': 'Dokumenty WZK',
  'goods_received_notes.options': 'Opcje',
  'goods_received_notes.sum_selected': 'Suma wybranych WZK brutto',
  'header.about_us': 'O nas',
  'header.account': 'Konto',
  'header.address': 'Adres',
  'header.brands': 'Marki',
  'header.categories': 'Kategorie',
  'header.choose_office': 'Wybierz oddział',
  'header.choose_right_office': 'Wybierz poprawny oddział',
  'header.hot_deals': 'Gorące okazje',
  'header.login': 'Zaloguj',
  'header.logout': 'Wyloguj',
  'header.manager': 'Twój opiekun',
  'header.messages': 'Wiadomości',
  'header.missing_warehouse_address': 'Brak informacji o adresie',
  'header.news': 'Nowości',
  'header.open_hours': 'Godziny otwarcia',
  'header.our_offices': 'Oddziały',
  'header.phone': 'Telefon',
  'header.PLN': 'PLN',
  'header.price_gross': 'z VAT',
  'header.price_net': 'bez VAT',
  'header.promotions': 'Promocje',
  'header.register': 'Załóż konto',
  'header.select_city': 'Wybierz/wpisz miasto',
  'header.select_office': 'Wybierz oddział',
  'header.selected_office': 'Wybrany oddział',
  'header.stepCart': 'Twój koszyk',
  'header.stepCheckoutData': 'Dane adresowe',
  'header.stepCheckoutSummary': 'Podsumowanie',
  'home.cms.list_with_megapopup.all': 'Wszystkie',
  'home.cms.top_products.errors.product_404': 'Produkt {product} nie istnieje',
  'home.cms.top_products.errors.product_not_set': 'Ustaw poprawny SKU produktu aby go pokazać',
  'home.cms.top_products.loading': 'Pobieranie',
  'invoices_details.corrections_fiscal_receipt': 'Korekty do paragonu',
  'invoices_details.corrections_invoice': 'Korekty do faktury',
  'invoices_details.detail_info': 'Dane szczegółowe',
  'invoices_details.download': 'Pobierz',
  'invoices_details.download_pdf': 'Pobierz fakturę',
  'invoices_details.goods_issue_notes': 'Numery WZ',
  'invoices_details.goods_received_notes': 'Notatki do towarów',
  'invoices_details.gross_value': 'Wartość brutto',
  'invoices_details.invoice_correction': 'Faktura do korekty',
  'invoices_details.invoice_reference_number': 'Numer referencyjny faktury',
  'invoices_details.is_not_paid_lang': 'Nie opłacono',
  'invoices_details.left_pay': 'Pozostało do zapłaty',
  'invoices_details.net_value': 'Wartość netto',
  'invoices_details.order_number': 'Numer zamówienia',
  'invoices_details.order_numbers': 'Numery zamówień',
  'invoices_details.paid_lang': 'Opłacono',
  'invoices_details.print': 'Drukuj',
  'invoices_details.products_in_invoice': 'Produkty dla faktury o numerze ',
  'invoices_details.purchase_numbers': 'Numery zakupu',
  'invoices_details.sale_date': 'Data sprzedaży',
  'invoices_details.status': 'Status faktury',
  'invoices_details.summary': 'Podsumowanie',
  'invoices_details.tax_rate': 'VAT',
  'invoices_details.tax_value': 'Wartość VAT',
  'invoices_details.value_paid': 'Wartość opłacona brutto',
  'invoices_details.your_order_number': 'Twój numer zamówienia',
  'invoices_info.account_number': 'Numer konta do wpłaty',
  'invoices_info.granted_amount': 'Przyznana kwota',
  'invoices_info.info': 'Jeśli chcesz zmienić kwote kredytu kupieckiego skontaktuj się ze swoim opiekunem.',
  'invoices_info.invoice_email_error': 'Nie udało się zapisać adresu do wysyłki e-faktur',
  'invoices_info.invoice_email_success': 'Zapisano adres do wysyłki e-faktur',
  'invoices_info.invoice_email_title': 'Adres do wysyłki e-faktur',
  'invoices_info.remaining_amount_used': 'Pozostała kwota do wykorzystania',
  'invoices_info.see_invoices': 'Zobacz faktury',
  'invoices_info.sum_unpaid_invoices': 'Suma nieopłaconych faktur',
  'invoices_info.term_payment': 'Termin płatności',
  'invoices_info.trade_credit': 'Kredyt kupiecki',
  'invoices_info.unpaid_invoices': 'Nieopłacone faktury',
  'invoices_info.update': 'Zapisz',
  'invoices.banner.message': 'Na twoim koncie znajdują się niezapłacone faktury po terminie, prosimy o uregulowanie płatności. ',
  'invoices.banner.show_more': 'Zobacz faktury',
  'invoices.category': 'Kategorie',
  'invoices.check_all_invoices': 'Zaznacz wszystkie faktury',
  'invoices.check_overdue_invoices': 'Pokaż przeterminowane faktury',
  'invoices.check_unpaid_invoices': 'Pokaż nieopłacone faktury',
  'invoices.date_header': 'Data wystawienia',
  'invoices.date_payment_header': 'Data płatności',
  'invoices.days_delays_header': 'Dni opóźnienia',
  'invoices.details_header': 'Szczegóły',
  'invoices.error_search': 'Nie znaleziono wyników wyszukiwania',
  'invoices.hide_details': 'Mniej',
  'invoices.invoice_number_header': 'Numer faktury/korekty',
  'invoices.lp': 'L.p',
  'invoices.more_details': 'Więcej',
  'invoices.search': 'Szukaj w fakturach',
  'invoices.search_placeholder': 'Wyszukaj',
  'invoices.show_invoice': 'Zobacz fakturę',
  'invoices.sum_remaining_invoice': 'Suma pozostała do zapłaty brutto',
  'invoices.sum_selected_invoice': 'Suma wybranych faktur brutto',
  'invoices.value_header': 'Wartość [brutto]',
  'login_page.back_login_page': 'Wróć na stronę logowania',
  'login_page.create_account_label': 'Załóż konto',
  'login_page.guest_checkout': 'Kup bez rejestracji',
  'login_page.create_account_label_extras': 'Zaloguj się, żeby śledzić i ponawiać swoje zamówienia',
  'login_page.user_exists': 'Masz już konto w naszym serwisie. Czy chcesz się zalogować?',
  'login_page.error_change_password': 'Wystąpił błąd',
  'login_page.forgot_password_label': 'Zapomniałeś hasła?',
  'login_page.incorrect_login': 'Podałeś nieprawidłowy login lub hasło',
  'login_page.login': 'E-mail',
  'login_page.login_label': 'Zaloguj się',
  'login_page.password': 'Hasło',
  'login_page.registration_label': 'Rejestracja',
  'login_page.reset_info': 'Na podany adres e-mail zostanie wysłana instrukacja odzyskania hasła',
  'login_page.reset_label': 'Zresetuj hasło',
  'login_page.reset_title': 'Zresetuj swoje hasło',
  'login_page.show_password': 'Pokaż hasło',
  'login_page.success_change_password': 'Na podany adres E-mail została wysłana instrukcja dotycząca odzyskania hasła',
  'login_page.title': 'Zaloguj się do konta',
  'my_account.add_photo': 'Dodaj zdjęcie',
  'my_account.admin': 'Administrator',
  'my_account.change_password': 'Zmień hasło',
  'my_account.login': 'Email/login',
  'my_account.name': 'Imię',
  'my_account.new_password': 'Nowe hasło',
  'my_account.notification_error': 'Nie powiodło się',
  'my_account.notification_update_password': 'Zaktualizowano dane',
  'my_account.notification_update_user': 'Zaktualizowano dane',
  'my_account.old_password': 'Stare hasło',
  'my_account.password': 'Hasło',
  'my_account.permissions': 'Uprawnienia',
  'my_account.phone': 'Numer telefonu',
  'my_account.title': 'Dane konta',
  'my_account.user': 'Uzytkownik',
  'new_user_account.add': 'Nowy użytkownik',
  'new_user_account.cancel': 'Cofnij',
  'new_user_account.edit': 'Edytuj użytkownika',
  'new_user_account.email': 'E-mail',
  'new_user_account.name': 'Imię i nazwisko',
  'new_user_account.password': 'Hasło',
  'new_user_account.phone': 'Numer telefonu',
  'new_user_account.rePassword': 'Powtórz hasło',
  'new_user_account.roles': 'Role',
  'new_user_account.save': 'Zapisz',
  'newsletter.btnText': 'Zapisz się',
  'newsletter.placeholder': 'Wprowadź swój adres e-mail...',
  'newsletter.text': 'Chcesz być na bieżąco i otrzymywać informacje o promocjach i innych akcjach?',
  'newsletter.title': 'Newsletter',
  'notifications_page.email_notifications': 'Powiadomienia email',
  'notifications_page.invoices': 'Faktury',
  'notifications_page.invoices_sent': 'Wysłano fakture',
  'notifications_page.offers': 'Oferty',
  'notifications_page.offers_suggestions': 'Sugestie ofert',
  'notifications_page.order_confirmation': 'Potwierdzenie zamówienia',
  'notifications_page.order_status': 'Status zamówienia',
  'notifications_page.order_waiting_pickup': 'Zamówienie czeka do odbioru',
  'notifications_page.order_waybill': 'Zamówienie wysłane listem przewozowym',
  'notifications_page.title': 'Ustawienia powiadomień',
  'offers_page.accept': 'zaakceptuj',
  'offers_page.created_date_filter': 'Data wystawienia',
  'offers_page.date_from': 'Data początkowa',
  'offers_page.date_to': 'Data końcowa',
  'offers_page.error_search': 'Nie znaleziono wyników wyszukiwania',
  'offers_page.expiration_date_filter': 'Obowiązująca do',
  'offers_page.found': 'Znaleziono',
  'offers_page.get_pdf': 'PDF',
  'offers_page.header.created_date': 'Data wystawienia',
  'offers_page.header.expiration_date': 'Obowiązująca do',
  'offers_page.header.offer_number': 'Numer oferty',
  'offers_page.header.preview': 'Podgląd',
  'offers_page.header.products_amount': 'Ilość produktów',
  'offers_page.header.rfq_number': 'Numer zapytania',
  'offers_page.header.status': 'Status',
  'offers_page.header.value': 'Wartość',
  'offers_page.header.version': 'Wersja',
  'offers_page.not_found': 'Nie znaleziono',
  'offers_page.offer_search': 'Szukaj w ofertach',
  'offers_page.offer_search_placeholder': 'Szukaj wg nr oferty lub zapytania ofertowego',
  'offers_page.status_filter': 'Status',
  'offers_page.status_filter_placeholder': 'Filtruj wg statusu',
  'offers_page.statuses.offered': 'Złożona',
  'offers_page.statuses.overdue': 'Przedawniona',
  'offers_page.statuses.won': 'Wygrana',
  'offers_page.title': 'Oferty',
  'offline': 'Obecnie jesteś offline. Sprawdź połączenie internetowe',
  'order_authorization_page.details': 'Autoryzuj',
  'order_authorization_page.error': 'Brak zamówień do autoryzacji',
  'order_authorization_page.name': 'Nazwa koszyka',
  'order_authorization_page.payment': 'Płatność',
  'order_authorization_page.price': 'Wartość [Brutto/Netto]',
  'order_authorization_page.user': 'Użytkownik',
  'order_detail.back': '< wróć do widoku zamówień',
  'order_detail.billing_address': 'Adres do faktury',
  'order_detail.client_purchase_number': 'Numer zamówienia klienta',
  'order_detail.contact_person': 'Osoba do kontaktu',
  'order_detail.courier': 'Kurier',
  'order_detail.date': 'Data',
  'order_detail.delivery_address': 'Adres dostawy',
  'order_detail.delivery_date': 'Data dostarczenia',
  'order_detail.delivery_method': 'Metoda dostawy',
  'order_detail.detail_note': 'Uwagi',
  'order_detail.estimate': 'Przewidywane doręczenie',
  'order_detail.full_value_basket': 'Łączna wartość',
  'order_detail.gross_price': 'Wartość [Netto/Brutto]',
  'order_detail.invoices': 'Faktury',
  'order_detail.manufacturer': 'Producent',
  'order_detail.manufacturer_index': 'Index producenta',
  'order_detail.net_price': 'Cena netto PLN',
  'order_detail.note': 'Notatki',
  'order_detail.order': 'Zamówienie',
  'order_detail.order_quantity': 'Zamówiona ilość',
  'order_detail.payment_method': 'Metoda płatności',
  'order_detail.pickup': 'Odbiór osobisty',
  'order_detail.purchase_no': 'Numer zamówienia',
  'order_detail.reserved_quantity': 'Ilość zarezerwowana',
  'order_detail.shipment': 'Przesyłka',
  'order_detail.shipments': 'Przesyłka',
  'order_detail.shipped_quantity': 'Ilość wysłana',
  'order_detail.status': 'Status',
  'order_detail.title': 'Produkty',
  'order_detail.user': 'Użytkownik',
  'order_detail.waybills': 'Listy przewozowe',
  'order.modals.renew_order.accept_button': 'Ponów',
  'order.modals.renew_order.actions': 'Akcje',
  'order.modals.renew_order.amount': 'Ilość',
  'order.modals.renew_order.cancel_button': 'Anuluj',
  'order.modals.renew_order.empty_products_list': 'Brak produktów które spełniają kryteria do ponownego zamówienia',
  'order.modals.renew_order.error_message': 'Nie możesz zamówić ponownie produktów niedostępnych',
  'order.modals.renew_order.header.actions': 'Akcje',
  'order.modals.renew_order.header.amount': 'Ilość',
  'order.modals.renew_order.header.price': 'Cena',
  'order.modals.renew_order.header.remove_selected_products': 'Usuń wybrane produkty',
  'order.modals.renew_order.header.select_all_products': 'Zaznacz wszystkie produkty',
  'order.modals.renew_order.header.warehouse': 'Magazyn',
  'order.modals.renew_order.price': 'Cena',
  'order.modals.renew_order.product_unavailable': 'Niedostępny',
  'order.modals.renew_order.product.add_product': 'Dodano {0} z {1} produktów do koszyka',
  'order.modals.renew_order.product.error': 'Poniższe produkty są niedostepne lub brak stanów magazynowych',
  'order.modals.renew_order.product.general_error': 'Brak wystarczajacej ilości w magazynie lub produkt niedostepny',
  'order.modals.renew_order.product.select': 'Zaznacz',
  'order.modals.renew_order.stock': 'Magazyn',
  'order.modals.renew_order.title': 'Ponów zamówienie',
  'orders_history_page.btn_pay': 'Zapłać',
  'orders_history_page.button_hide_more.hide': 'Mniej',
  'orders_history_page.button_hide_more.more': 'Więcej',
  'orders_history_page.button_hide_more.show': 'Pokaż',
  'orders_history_page.details.address_text': 'Adres',
  'orders_history_page.details.courier': 'Kurier',
  'orders_history_page.details.export_pdf_text': 'Export PDF',
  'orders_history_page.details.export_to_file_text': 'Export do pliku',
  'orders_history_page.details.location_text': 'Lokalizacja',
  'orders_history_page.details.more_shipment': 'Zobacz szczegóły zamówienia',
  'orders_history_page.details.price_text': 'Koszty',
  'orders_history_page.details.shipment_text': 'Zamówienie',
  'orders_history_page.details.status_text': 'Status',
  'orders_history_page.details.view_order_text': 'Zobacz zamówienie',
  'orders_history_page.details.view_shipment': 'Zobacz zamówienie',
  'orders_history_page.details.warehouse': 'Magazyn',
  'orders_history_page.error_search': 'Nie znaleziono wyników wyszukiwania',
  'orders_history_page.found': 'Znaleziono',
  'orders_history_page.header.date': 'Data',
  'orders_history_page.header.details': 'Szczegóły',
  'orders_history_page.header.order': 'Zamówienie',
  'orders_history_page.header.pay': 'Brutto/Netto',
  'orders_history_page.header.payment': 'Płatność',
  'orders_history_page.header.user': 'Użytkownik',
  'orders_history_page.not_found': 'Nie znaleziono',
  'orders_history_page.order_offline': 'Zamówienia offline',
  'orders_history_page.order_online': 'Zamówienia online',
  'orders_history_page.order_search': 'Szukaj w zamówieniach',
  'orders_history_page.order_statuses': 'Statusy zamówień',
  'orders_history_page.title': 'Historia zamówień',
  'pages.account': 'Konto',
  'pages.account_info': 'Dane konta',
  'pages.addresses': 'Adresy',
  'pages.agreements': 'Zgody',
  'pages.billing': 'Dane do faktury',
  'pages.blog': 'Blog',
  'pages.cart': 'Koszyk',
  'pages.checkout': 'Dane adresowe',
  'pages.complains': 'Reklamacje',
  'pages.contact': 'Dane kontaktowe',
  'pages.goods_issue_notes': 'Dokumenty WZ',
  'pages.goods_received_notes': 'Dokumenty WZK',
  'pages.index': 'Strona główna',
  'pages.invoices': 'Faktury',
  'pages.invoices_goods_issue_notes': 'Faktury i dokumenty WZ',
  'pages.offers': 'Oferty',
  'pages.offline_orders': 'Zamówienia offline',
  'pages.online_orders': 'Zamówienia online',
  'pages.order_authorization': 'Zamówienia do autoryzacji',
  'pages.order_summary': 'Podsumowanie zamówienia',
  'pages.orders_history': 'Historia zamówień',
  'pages.rfq': 'Zapytania ofertowe',
  'pages.rfqs_offers': 'Oferty i zapytania ofertowe',
  'pages.roles': 'Role',
  'pages.users': 'Użytkownicy',
  'pages.wishlist': 'Schowek',
  'powered_by': 'Powered by',
  'price.gross': 'brutto',
  'price.lowest_price': 'Najniższa cena w ciągu ostatnich {0} dni',
  'price.net': 'netto',
  'product_block.cannot_add': 'Nie można dodać',
  'product_block.invalid_amount': 'Ilość żądania jest nieprawidłowa',
  'product_block.is_blocked': 'jest zablokowane',
  'product_block.no_price_available': 'Cena tego produktu jest niedostępna',
  'product_block.product': 'Produkt',
  'product_block.product_blocked_one': 'Nie możesz dodać produktu za pomocą SKU',
  'product_block.product_blocked_two': 'z następującymi etykietami:',
  'product_block.text': 'Maksymalna możliwa ilość do zakupu to ',
  'product_block.title_one': 'Nie ma możliwości dodania ',
  'product_block.title_two': ' do koszyka ponad stan magazynowy',
  'product_page.add_to_cart': 'Dodaj produkt do koszyka',
  'product_page.add_to_wishlist': 'Dodaj do listy zakupowej',
  'product_page.alert_added_all_to_cart': 'Wszystkie produkty dodano do koszyka',
  'product_page.alert_added_to_cart': 'Dodano do koszyka',
  'product_page.alert_added_to_wishlist': 'Dodano do listy zakupowej',
  'product_page.brand': 'Marka',
  'product_page.brand_description': 'O marce',
  'product_page.category': 'Kategoria',
  'product_page.certificates': 'Certyfikaty',
  'product_page.complementary_products': 'Produkty powiązane',
  'product_page.data_sheets': 'Karty produktu',
  'product_page.description': 'Opis',
  'product_page.discount': 'Rabat',
  'product_page.download': 'Do pobrania',
  'product_page.hour': 'h',
  'product_page.insufficient_quantity_stock': 'Brak wystarczajacej ilości w magazynie',
  'product_page.interval_qty': 'Interwał',
  'product_page.login_or_register_to_buy': 'Zaloguj się lub zarejestruj aby kupić',
  'product_page.login_to_buy': 'Zaloguj się aby kupić',
  'product_page.manufacturer': 'Producent',
  'product_page.manufacturer_index': 'Kod produktu',
  'product_page.catalog_index': 'EAN produktu',
  'product_page.min_qty': 'Minimum',
  'product_page.more_stocks': 'Zobacz więcej magazynów ({count})',
  'product_page.price_unavailable': 'Produkt na zapytanie',
  'product_page.product_id': 'Kod produktu',
  'product_page.product_options': 'Opcje produktu',
  'product_page.product_size': 'Rozmiar produktu',
  'product_page.related_accessories': 'Polecane akcesoria',
  'product_page.related_products': 'Podobne produkty',
  'product_page.related_products.actions': 'Akcje',
  'product_page.related_products.availability': 'Dostępność',
  'product_page.related_products.price': 'Cena',
  'product_page.related_products.show_more': 'Pokaż więcej',
  'product_page.related_products.variants': 'Warianty produktowe',
  'product_page.series': 'Seria',
  'product_page.shipping_time': 'Czas wysyłki',
  'product_page.technical_data': 'Dane techniczne',
  'product_page.unavailable': 'Informacje o stanach magazynowych niedostępne',
  'product_page.usage': 'Działanie produktu',
  'products_list.categories': 'Kategorie',
  'products_list.delete_all_filters': 'Usuń wszystkie filtry',
  'products_list.empty.default': 'Niestety nie mamy w ofercie produktów spełniających Twoje oczekiwania.',
  'products_list.empty.link_container': 'Zmień podane kryteria lub {0}.',
  'products_list.empty.link_text': 'zobacz wszystkie produkty w {0}',
  'products_list.empty.not_found': 'Nie znaleziono produktu "{0}" dla ustawionych filtrów. Czy chcesz przeszukać w całym katalogu?',
  'products_list.empty.search': 'Przeszukaj',
  'products_list.filters': 'Filtry',
  'products_list.found_items': 'Znaleziono',
  'products_list.no_categories': 'Nie znaleziono kategorii',
  'products_list.price': 'Cena',
  'products_list.promotions': 'Promocje',
  'products_list.searched_in_all_categories': 'Przeszukaliśmy wszystkie kategorie, oto wyniki:',
  'products_list.select_filters': 'Wybrane filtry',
  'products_list.show_products': 'Pokaż produkty',
  'products_list.sort_high_price': 'Sortuj: najwyższa cena',
  'products_list.sort_low_price': 'Sortuj: najniższa cena',
  'products_list.sort_name_ascending': 'Sortuj: nazwa rosnąco',
  'products_list.sort_name_descending': 'Sortuj: nazwa malejąco',
  'pwa.reload': 'Odśwież',
  'pwa.update': 'Jest dostępna nowa wersja aplikacji',
  'registration.account': 'Konto',
  'registration.address': 'Dane adresowe',
  'registration.agreements': 'Zgody',
  'registration.choose_account_type': 'Wybierz rodzaj konta',
  'registration.company_label': 'Firma',
  'registration.company.city': 'Miejscowość',
  'registration.company.code_guardian': 'Kod twojego opiekuna',
  'registration.company.country': 'Kraj',
  'registration.company.department': 'Oddział',
  'registration.company.name': 'Nazwa firmy',
  'registration.company.street': 'Ulica i numer',
  'registration.company.tin': 'NIP',
  'registration.company.zip_code': 'Kod pocztowy',
  'registration.contact_person': 'Osoba do kontaktu',
  'registration.customer_label': 'Osoba prywatna',
  'registration.data_download_error': 'Błąd pobierania danych adresowych',
  'registration.data_downloaded': 'Pobrano dane adresowe',
  'registration.email': 'E-mail/Login',
  'registration.errors.country_required': 'Kraj jest wymagany',
  'registration.errors.default': 'Nie udało się utworzyć nowego klienta',
  'registration.errors.email_in_use': 'Podany adres email istnieje w systemie. Proszę skontaktować się z działem obsługi klienta.',
  'registration.errors.invalid_email': 'Podany adres email jest nieprawidłowy',
  'registration.errors.tin_in_use': 'Podany numer NIP istnieje w systemie. Proszę skontaktować się z działem obsługi klienta.',
  'registration.field_minimum': 'Pole {name} musi zawierać minimum',
  'registration.field_required': 'Pole {name} jest wymagane',
  'registration.get_gus_data': 'Pobierz z GUS',
  'registration.info.four': 'indywidualne akcje promocyjne',
  'registration.info.one': 'Indywidualne warunki handlowe',
  'registration.info.three': 'panel klienta',
  'registration.info.title': 'Dołącz do nas',
  'registration.info.two': 'dedykowanego opiekuna handlowego',
  'registration.invoice': 'Dane do faktury',
  'registration.isNotValid': 'Uzupełnij wszystkie pola',
  'registration.name': 'Imię i nazwisko',
  'registration.password': 'Hasło',
  'registration.password_error': 'Hasło jest wymagane. Musisz wpisać jedną wielką literę, jedną cyfrę lub znak specjalny, min. 8 znaków',
  'registration.phone': 'Telefon',
  'registration.re_password': 'Powtórz hasło',
  'registration.rules_lowercase': '1 małą literę',
  'registration.rules_min': 'znaków',
  'registration.rules_special_char': '1 cyfrę lub 1 znak specjalny',
  'registration.rules_uppercase': '1 wielką literę',
  'registration.save': 'Zarejestruj się',
  'registration.success': 'Udało się utworzyć nowego klienta',
  'registration.tin_not_found': 'Nie znaleziono numeru NIP',
  'registration.title': 'Dane konta',
  'registration.user_data': 'Dane konta',
  'rfq_detail.back': '< wróć do widoku zamówień',
  'rfq_detail.billing_address': 'Adres do faktury',
  'rfq_detail.contact_person': 'Osoba do kontaktu',
  'rfq_detail.courier': 'Kurier',
  'rfq_detail.delivery_address': 'Adres dostawy',
  'rfq_detail.delivery_date': 'Data dostarczenia',
  'rfq_detail.delivery_method': 'Metoda dostawy',
  'rfq_detail.detail_note': 'Uwagi',
  'rfq_detail.estimate': 'Przewidywane doręczenie',
  'rfq_detail.full_value_basket': 'Łączna wartość',
  'rfq_detail.gross_price': 'Wartość [Netto/Brutto]',
  'rfq_detail.invoices': 'Faktury',
  'rfq_detail.manufacturer': 'Producent',
  'rfq_detail.manufacturer_index': 'Index producenta',
  'rfq_detail.net_price': 'Cena netto PLN',
  'rfq_detail.note': 'Notatki',
  'rfq_detail.order': 'Zapytanie ofertowe',
  'rfq_detail.order_quantity': 'Zamówiona ilość',
  'rfq_detail.payment_method': 'Metoda płatności',
  'rfq_detail.pickup': 'Odbiór osobisty',
  'rfq_detail.purchase_no': 'Numer zamówienia',
  'rfq_detail.shipment': 'Przesyłka',
  'rfq_detail.shipments': 'Przesyłka',
  'rfq_detail.shipped_quantity': 'Ilość wysłana',
  'rfq_detail.status': 'Status',
  'rfq_detail.title': 'Produkty',
  'rfq_detail.user': 'Użytkownik',
  'rfq_detail.waybills': 'Listy przewozowe',
  'rfq_page.button_hide_more.hide': 'Mniej',
  'rfq_page.button_hide_more.more': 'Więcej',
  'rfq_page.details.address_text': 'Adres',
  'rfq_page.details.courier': 'Kurier',
  'rfq_page.details.export_pdf_text': 'Export PDF',
  'rfq_page.details.export_to_file_text': 'Export do pliku',
  'rfq_page.details.location_text': 'Lokalizacja',
  'rfq_page.details.more_shipment': 'Zobacz szczegóły zapytania',
  'rfq_page.details.price_text': 'Koszty',
  'rfq_page.details.shipment_text': 'Zapytanie ofertowe',
  'rfq_page.details.status_text': 'Status',
  'rfq_page.details.status.sent': 'Wysłano',
  'rfq_page.details.view_order_text': 'Zobacz zapytanie ofertowe',
  'rfq_page.details.view_shipment': 'Zobacz zapytanie ofertowe',
  'rfq_page.details.warehouse': 'Magazyn',
  'rfq_page.error_search': 'Nie znaleziono wyników wyszukiwania',
  'rfq_page.found': 'Znaleziono',
  'rfq_page.header.date': 'Data',
  'rfq_page.header.details': 'Szczegóły',
  'rfq_page.header.order': 'Oferta',
  'rfq_page.header.pay': 'Brutto/Netto',
  'rfq_page.header.payment': 'Płatność',
  'rfq_page.header.user': 'Użytkownik',
  'rfq_page.not_found': 'Nie znaleziono',
  'rfq_page.order_offline': 'Zamówienia offline',
  'rfq_page.order_online': 'Zapytania ofertowe',
  'rfq_page.order_search': 'Szukaj w ofertach',
  'rfq_page.rfq_search': 'Szukaj w zapytaniach ofertowych',
  'rfq_page.title': 'Zapytania ofertowe',
  'roles_page_list_element.tooltip.edit_role': 'Edytuj role',
  'roles_page_list_element.tooltip.info': 'Zobacz uprawnienia roli',
  'roles_page_list_element.tooltip.remove_role': 'Usuń role',
  'roles_page.add_role': 'Dodaj nową role',
  'roles_page.cancel': 'Anuluj',
  'roles_page.edit_role': 'Edytuj role',
  'roles_page.label_permissions': 'Uprawnienia',
  'roles_page.label_role': 'Nazwa roli',
  'roles_page.notif_create_role': 'Utworzono role',
  'roles_page.notif_delete_role': 'Usunięto rolę',
  'roles_page.notif_edit_role': 'Rola została zaaktualizowana',
  'roles_page.notif_error': 'Nie udało się',
  'roles_page.save': 'Zapisz',
  'roles_page.title': 'Role',
  'search.all_categories': 'Wszystkie kategorie',
  'search.category_breadcrumb': "Wyszukiwanie w kategorii '{categoryName}'",
  'search.default_breadcrumb': 'Wyszukiwarka',
  'search.filter_date': 'Wybierz przedział dat',
  'search.filter_end_date': 'Data końcowa',
  'search.filter_start_date': 'Data początkowa',
  'search.placeholder': 'Czego szukasz...',
  'search.query_breadcrumb': "Wyniki wyszukiwania dla '{searchString}'",
  'search.suggest.categories': 'Kategorie',
  'search.suggest.manufacturers': 'Producenci',
  'search.suggest.products': 'Produkty',
  'sidebar.advices': 'Porady',
  'sidebar.categories': 'Kategorie',
  'sidebar.manufacturers': 'Producenci',
  'sidebar.messages': 'Wiadomości',
  'sidebar.promotions': 'Promocje',
  'sidebar.sales': 'Wyprzedaże',
  'sidebar.title': 'Menu',
  'user_page_list_element.logged': 'Zalogowany użytkownik',
  'user_page_list_element.reset_password': 'Zresetuj hasło',
  'user_page_list_element.reset_password_message': 'Na adres email {0} wysłano link resetujący hasło',
  'user_page_list_element.reset_password_modal_text': 'Czy na pewno chcesz zresetować hasło dla {0}?',
  'user_page_list_element.tooltip.block_user': 'Blokuj użytkownika',
  'user_page_list_element.tooltip.delete_user': 'Usuń użytkownika',
  'user_page_list_element.tooltip.edit_user': 'Edytuj użytkownika',
  'user_page_list_element.tooltip.unblock_user': 'Odblokuj użytkownika',
  'user_page.add_users': 'Dodaj użytkownika',
  'user_page.error': 'Operacja nie powiodła się',
  'user_page.error_user_exists': 'Użytkownik o podanym adresie istnieje',
  'user_page.information_create_new_user': 'Utworzono nowego użytkownika:',
  'user_page.login': 'Login:',
  'user_page.password': 'Hasło:',
  'user_page.permissions': 'Uprawnienia',
  'user_page.remove_user': 'Usunięto użytkownika',
  'user_page.roles': 'Role',
  'user_page.search': 'Szukaj w użytkownikach',
  'user_page.search_placeholder': 'Szukaj w użytkownikach',
  'user_page.success_add_user': 'Dodano nowego użytkownika',
  'user_page.success_edit_user': 'Edytowano użytkownika',
  'user_page.title': 'Użytkownicy',
  'user_page.update': 'Zaktualizowano',
  'wishlist.add_all': 'Dodaj wszystko',
  'wishlist.tooltip.cable_add': 'Produkty kablowe dodawaj pojedynczo za pomocą ikony koszyka',
  'wishlist.create_cart_from_wishlist': 'Stwórz koszyk z listy zakupowej',
  'wishlist.default_name': 'Lista zakupowa',
  'wishlist.dropdown.add_new': 'Dodaj nową listę zakupową',
  'wishlist.dropdown.delete': 'Usuń aktualną listę zakupową',
  'wishlist.dropdown.rename': 'Zmień nazwę',
  'wishlist.empty_wishlist': 'Lista zakupów jest pusta',
  'wishlist.modals.add_placeholder': 'Wprowadź nazwę listy zakupowej',
  'wishlist.modals.add_title': 'Stwórz nową listę zakupową',
  'wishlist.modals.cancel_btn': 'Anuluj',
  'wishlist.modals.input_not_valid': 'Za długa nazwa listy zakupowej',
  'wishlist.modals.remove_confirm_btn': 'Usuń',
  'wishlist.modals.remove_text': 'Proszę potwierdzić usunięcie listy zakupowej',
  'wishlist.modals.remove_title': 'Usuń',
  'wishlist.modals.rename_ok_btn': 'Zmień nazwę',
  'wishlist.modals.rename_placeholder': 'Wpisz nazwę',
  'wishlist.modals.rename_title': 'Zmiana nazwy listy zakupowej',
  'wishlist.modals.save_btn': 'Zapisz',
  'wishlist.modals.wishlist_created': 'Lista stworzona',
  'wishlist.modals.wishlist_removed': 'Usunięto listę zakupową',
  'wishlist.modals.wishlist_renamed': 'Nazwa została zmieniona',
  'utils.add': 'Dodaj',
  'cart.promotions': 'Promocje',
  'cart.promotions.reset': 'Resetuj promocje',
  'cart.promotions.reset.success': 'Pomyślnie zresetowano promocje',
  'cart.promotions.link': 'Link',
  'cart.promotions.granted': 'Przyznane promocje',
  'cart.promotions.added': 'Promocje dodane',
  'cart.promotions.available.list': 'Lista dodatkowych promocji',
  'cart.promotions.not_available': 'Brak dostępnych promocji dodatkowych',
}
